import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { browserHistory } from '@americanexpress/one-app-router';
import PropTypes from 'prop-types';
import { Button } from '@americanexpress/dls-react';
import getLinks from '../utils/linksUtils';

const GlobalErrorPage = ({ route, location }) => {
  const { pathname } = location;
  const intl = useIntl();
  const state = route.store.getState();
  const currentEnv = state.getIn(['config', 'linkKey']);
  const reconLinks = getLinks('recon', currentEnv);
  const eidLinks = getLinks('oneData', currentEnv);
  const [childRouteNotFound, setChildRouteNotFound] = useState(true);
  useEffect(() => {
    if (pathname.indexOf('error') !== -1) {
      setChildRouteNotFound(false);
    }
  }, [pathname]);
  const { enterpriseLoginUrl, enterpriseHomepageUrl } = eidLinks;
  const { reconPortalAdvUrl } = reconLinks;
  const redirectUser = (linkToRedirect) => {
    if (linkToRedirect) {
      window.location.assign(linkToRedirect);
    } else {
      browserHistory.goBack();
    }
  };

  return (
    <>
      <div
        className="shadow-2 dls-white-bg margin-auto-lr pad-2-b"
        data-testid="error-root"
      >
        <div data-module-name="identity-components-message">
          <div className="dls-white-bg pad flex flex-column flex-align-center">
            <span
              className="icon dls-icon-warning icon-lg margin-2-tb dls-color-warning"
              data-testid="card_icon"
            />
            <h1 className="heading-4 margin-1-b" data-testid="error_header">
              {intl.formatMessage({ id: '404.error.header' })}
            </h1>
            <p className="body-3" data-testid="error_desc">
              {intl.formatMessage({ id: '404.error.message' })}
            </p>
          </div>
          <hr />
          <div className=" margin-2-t text-align-center margin-2-lr">
            <div className="group-primary">
              <Button
                className="border-0 margin-1-r"
                data-testid="back-to-eid"
                onClick={(e) => {
                  e.preventDefault();
                  redirectUser(childRouteNotFound ? enterpriseLoginUrl : '');
                }}
              >
                {intl.formatMessage({ id: 'go.back.previous.page' })}
              </Button>
              |
              <Button
                className="border-0 margin-1-l"
                data-testid="back-to-recon"
                onClick={(e) => {
                  e.preventDefault();
                  redirectUser(
                    childRouteNotFound
                      ? reconPortalAdvUrl
                      : enterpriseHomepageUrl
                  );
                }}
              >
                {intl.formatMessage({
                  id: childRouteNotFound
                    ? 'go.back.to.app.page'
                    : 'go.to.american.express.page',
                })}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

GlobalErrorPage.propTypes = {
  route: PropTypes.shape({
    store: PropTypes.shape({
      getState: PropTypes.func,
    }),
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default GlobalErrorPage;
